import styled from "styled-components";
import { media } from "../../utils/helper";

const StyledText = styled(({ children, as: Component, ...props }) => (
  <Component {...props}>{children}</Component>
))`
  ${({ $fontSize }) => `${$fontSize ? "font-size:" + $fontSize : ""};`}
  color: ${({ color, theme }) =>
    color
      ? theme?.colors[color]
      : theme.colors?.secondary || theme?.colors?.secondary};
  font-weight: ${({ $fontWeight }) => ($fontWeight ? $fontWeight : 400)};
  ${({ isHover, theme }) =>
    isHover && `cursor: pointer; &:hover {color: ${theme.colors.primary}}`};
  ${media.md`
       ${({ $fontSizeMd }) => `${$fontSizeMd ? "font-size:" + $fontSizeMd : ""};`}
       `}
`;

StyledText.defaultProps = {
  as: "span",
};

export default StyledText;
